import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AppMainService } from 'src/app/app-main.service';
import { Fields } from '../../models/column-settings.model';
import { ImportserialService } from '../../services/importserial.service';
import { SerialType } from '../../enums/serial-details.enum';

@Component({
  selector: 'app-activation-residual-details',
  templateUrl: './activation-residual-details.component.html',
  styleUrls: ['./activation-residual-details.component.scss']
})
export class ActivationResidualDetailsComponent implements OnChanges {
  @Input() selectedSerial = null;
  @Input() selectedChannel = '';
  @Input() cols = [];
  data: any[] = [];
  pageSize: number = 15;
  pageNumber: number = 1;
  totalRecord: number = 0;
  pageNumber2: number = 1;
  first: number = 0;
  rowsPerPage = [15, 30, 50, 100];
  reportTotalRowSum: any = {};
  reportTotalRowAvg: any = {};
  typeId: number = 0;
  aggregateTypes = [
    { type: 'Total', code: 'Sum' },
    { type: 'Avg', code: 'Avg' },
  ];
  activeCols = [];
  searchCols = [];
  selectedGroupByValue: any = null;
  selectedGroupBy: any = null;
  selectedAggregateTypeByValue: any = null;
  selectedAggregateTypeBy: any = null;
  enabledListCols: Fields[] = [];
  /**Filter**/
  filterCols = [];
  filters = [];
  searchValue: string = '';

  constructor(private importService: ImportserialService, private appMainService: AppMainService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cols && changes.cols.currentValue) {
      this.cols = changes.cols.currentValue;
      this.typeId = this.serialTypeId;
      this.cols = this.cols?.filter(col => col.typeId == this.typeId).map(column => column.ListCols)[0];
      this.activeCols = this.cols.filter(e => e.checked && e.show);
      this.getFilterColumns();
      this.loadList(this.typeId);
    }else if(changes.selectedSerial?.currentValue){
      this.typeId = this.serialTypeId;
      this.getFilterColumns();
      this.loadList(this.typeId);
    }
  }

  get serialTypeId() {
    return (this.selectedChannel == 'Activation Details') ? SerialType.Activation : SerialType.Residual;
  }

  showGroupBy() {
    this.enabledListCols = this.cols?.filter(col => col.checked && col.show);
    this.selectedGroupBy = this.selectedGroupByValue || null;
    this.selectedAggregateTypeBy = this.selectedAggregateTypeByValue || null;
  }

  applyGroup() {
    this.selectedGroupByValue = this.selectedGroupBy;
    this.selectedAggregateTypeByValue = this.selectedAggregateTypeBy;
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.searchCols = this.cols?.map(col => ({
      columnName: col.field,
      isCustom: false
    }));
    this.loadList(this.typeId);
  }

  loadList(typeId: number) {
    this.data = [];
    if (this.selectedGroupBy) {
      this.getActivationAndResidualsDataByGroup(this.pageNumber, this.pageSize, this.typeId, this.filters, this.searchValue, this.searchCols, this.selectedGroupBy?.field, this.selectedSerial?.serialId)
    } else {
      this.getActivationAndResidualsData(this.pageNumber, this.pageSize, this.typeId, this.filters, this.searchValue, this.searchCols, this.selectedGroupBy?.field, this.selectedSerial?.serialId)
    }
  }

  resetGroup() {
    this.selectedGroupBy = null;
    this.selectedGroupByValue = null;
    this.selectedAggregateTypeBy = null;
    this.selectedAggregateTypeByValue = null;
    this.loadList(this.typeId);
  }

  getChildData(event, rowData) {
    this.pageNumber2 = event.first / event.rows + 1;
    this.getActivationAndResidualsSubGroup(this.pageNumber2, 15, this.typeId, this.filters, this.searchValue, this.searchCols, this.selectedGroupByValue?.field, rowData, this.selectedSerial?.serialId);
  }

  getData(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.loadList(this.typeId);
  }

  getFilterColumns() {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getFilterData(this.typeId)
      .subscribe({
        next: (res) => {
          this.filterCols = res;
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  applyFilters(data) {
    this.filters = data.selectedFilter ?? [];
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.loadList(this.typeId);
  }

  getActivationAndResidualsData(pageNumber: number, pageSize: number, typeId: number, filters: any[], searchValue: string, searchCols: any[], groupCol: string, serialId: number) {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getActivationAndResidualsData(pageNumber, pageSize, typeId, filters, searchValue, searchCols, groupCol, serialId)
      .subscribe({
        next: (res) => {
          let { serialDetails, headers } = res;
          serialDetails = serialDetails ?? [];
          headers = headers ?? [];
          this.data = serialDetails ?? [];
          this.totalRecord = headers["TotalCount"] ? headers["TotalCount"] : 0;
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  getActivationAndResidualsDataByGroup(pageNumber: number, pageSize: number, typeId: number, filters: any[], searchValue: string, searchCols: any[], groupCol: string, serialId: number) {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getActivationAndResidualsDataByGroup(pageNumber, pageSize, typeId, filters, searchValue, searchCols, groupCol, serialId)
      .subscribe({
        next: (res) => {
          let { serialDetails, headers } = res;
          serialDetails = serialDetails ?? [];
          headers = headers ?? [];
          this.data = serialDetails.groupedList ?? [];
          this.reportTotalRowSum = serialDetails.grandSumMap;
          this.reportTotalRowAvg = serialDetails.grandAvgMap;
          this.totalRecord = headers["TotalCount"] ? headers["TotalCount"] : 0;
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  getActivationAndResidualsSubGroup(pageNumber: number, pageSize: number, typeId: number, filters: any[], searchValue: string, searchCols: any[], groupBy, rowData, serialId: number) {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getActivationAndResidualsSubGroupData(pageNumber, pageSize, typeId, filters, searchValue, searchCols, groupBy, rowData.groupByValue, serialId)
      .subscribe({
        next: (res) => {
          rowData.list = res.list;
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

}
